import { Component, Input, OnInit } from '@angular/core';
import {
  Platform,
  PopoverController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { LocalStorageNativeService } from 'src/services/NativeLocalStorage.service';
import { OnboardingStore } from '@boxx/onboarding-core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'boxx-totalplay',
  templateUrl: './totalplay.component.html',
  styleUrls: ['./totalplay.component.scss'],
})
export class TotalplayComponent implements OnInit {
  @Input() countOpen: number;

  translations: any;
  destroyed$ = new Subject<boolean>();
  third_id: string;
  revealImage = false;
  isUpdating = false;

  dataForm: FormGroup | any;

  constructor(
    public platform: Platform,
    private popoverCtrl: PopoverController,
    private translate: TranslateService,
    public storageService: LocalStorageNativeService,
    private storeBusiness: OnboardingStore,
    private boxxUtils: BoxxUtilsService
  ) {
    this.translate
      .get(['QR', 'CLIPBOARD', 'PANEL_VIEW', 'ERRORS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));

    this.platform.ready().then(() => {

    });
  }

  ngOnInit() {
    this.dataForm = new FormGroup({
      third_id : new FormControl('', Validators.required),
    });
    this.handleSuccess();
    this.handleError();
    //this.handleLoading();
  }

  // private handleLoading() {
  //   this.storeBusiness.businessConfig.businessIsLoading$
  //     .pipe(takeUntil(this.destroyed$))
  //     .subscribe((isLoading) => {
  //       setTimeout( () => {
  //         this.boxxUtils.handleLoading(isLoading)
  //       }, 500);
  //     });
  // }

  private handleSuccess() {
    this.storeBusiness.businessConfig.businessSuccess$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((success) => {
        if(success && success.after === 'UPDATE'){
          this.isUpdating = false;
          this.boxxUtils.showToastSuccess({
            message: this.translations.PANEL_VIEW.WIDGET.TOTALPLAY.updateMsg,
          });
          this.close();
        }
      });
  }

  private handleError() {
    this.storeBusiness.businessConfig.businessError$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((error) => {
        if (error?.after === 'UPDATE') {
          this.isUpdating = false;
          this.boxxUtils.showToastError({
            message: this.translations.ERRORS.ACCOUNT.update_error,
          });
        }
      });
  }

  showHelp(){
    this.revealImage = !this.revealImage;
  }

  async close() {
    this.popoverCtrl.dismiss();

  }

  async updateData() {
    const values = this.dataForm.value;
    if(!values.third_id || values.third_id.length !== 10){
      this.boxxUtils.showToastError({
        message: this.translations.ERRORS.ACCOUNT.totalplay_error,
      });
      return;
    }
    this.isUpdating = true;
    this.storeBusiness.businessConfig.updateBusinessData({
      third_id: this.dataForm.value.third_id
    });
  }

}
